<app-side-color-card color="in">
  <div content>
    <div class="title">
        <app-prev-next-button (click)="returnToTable()" [direction]="'left'" [label]="title"></app-prev-next-button>
      </div>
    <div class="table">
      <div class="empty" *ngIf="!positions || positions.length === 0">
        POSIÇÃO NÃO ENCONTRADA.
      </div>

      <div class="header" *ngIf="positions?.length !== 0">
        <div class="position column">Posição</div>
        <div class="position column">Apelido</div>
        <div class="rfid column">QR Code</div>
        <div class="sector column">Setor</div>
        <div class="type column">Tipo</div>
        <div class="column">Estado</div>
        <div class="toggle column">Bloqueado</div>
        <div class="tag column">Trocar QR Code</div>
        <div class="button column edit-sector">Editar Apelido</div>
      </div>

      <div class="item" *ngFor="let position of positions">
        <div class="position column">{{ formatPosition(position.column, position.row) }}</div>
        <div class="position column">{{ position.alias || '---' }}</div>
        <div class="rfid column">{{ position.qrCode || '---' }}</div>
        <div class="sector column">{{ position.groupName || '---' }}</div>
        <div class="type column">{{ translateType(position.type) }}</div>
        <div class="column">{{ translateState(position.state) || '---' }}</div>
        <div class="toggle column">
          <mat-slide-toggle (change)="onToggleChange($event, position)"
            [checked]="position.state === stateEnum.BLOCKED"
            [disabled]="position.state === stateEnum.MARKED_TO_REPLACE_QR_CODE">
          </mat-slide-toggle>
        </div>
        <div class="button tag column">
          <button mat-raised-button class="primary-2" (click)="markQRCodeToBeChanged(position)" 
            *ngIf="position.state !== stateEnum.MARKED_TO_REPLACE_QR_CODE"
            [disabled]="position.state === stateEnum.BLOCKED">
            marcar para troca de qr code
          </button>
          <button mat-raised-button class="alert-background" (click)="markQRCodeToAsReady(position)" 
            *ngIf="position.state === stateEnum.MARKED_TO_REPLACE_QR_CODE"
            [disabled]="position.state === stateEnum.BLOCKED">
            remover marcação para troca de qr code
          </button>
        </div>
        <div class="button column edit-sector">
          <button mat-raised-button class="primary-2" (click)="editAlias(position)">editar apelido</button>
        </div>
      </div>
    </div>
  </div>
</app-side-color-card>
